


import { Component, Vue } from 'vue-property-decorator';
import VueToastr from '@deveodk/vue-toastr';
import { JobAlertUI } from '../../models/JobAlert/JobAlertUI';
import { JobAlertV2 } from '../../models/JobAlert/JobAlertV2';
import { vxm } from './../../store.vuex';
import VueGoogleAutocomplete from 'vue-google-autocomplete';
import { CommonJobAlert } from '../../models/JobAlert/commonjobalert';
import { CommonJobAlertV2 } from '../../models/JobAlert/commonjobalertv2';
import { AlertConfigDetails } from '../../models/JobAlert/alertconfigdetails';
import { Filter } from '../../../src/models/jobs/filter';
import { Geolocation } from '../../models/jobs/geolocation';
import { JobDeleteV2 } from '../../models/JobAlert/JobAlertDeleteV2';
import { JobAlertPauseV2 } from '../../models/JobAlert/JobAlertPauseV2';
import { JobAlertListV2 } from '../../models/JobAlert/JobAlertListV2';
import { NotificationPreferences } from '../../models/userdata/notificatonmap';
import { Latlong } from '../../models/jobs/latlong';
import { Locale } from '../../models/jobs/locale';
import JobAlertPagination from './JobAlertPagination.vue';
import Loader from './../Loader.vue';
import ConfirmationModalV2 from '../Commons/ConfirmationModalV2.vue';
import JobAlertEditPopUp from '../JobAlert/JobAlertEditPopUp.vue';
import router from '../../router';
import { Pager } from '../../models/jobs/pager';
import { JobAlertLocationInfo } from './JobAlertLocationInfo';
import { UserProfile } from '../../models/userdata/profile';
import { JobSearchRequestPayload } from '@/components/SearchFilter/JobSearchRequestPayload';
Vue.use(VueToastr, {
  defaultPosition: 'toast-top-right',
  defaultType: 'info',
  defaultTimeout: 5000,
});

@Component({
  name: 'JobAlertPageV2',
  components: {
    VueGoogleAutocomplete,
    Loader,
    JobAlertPagination,
  },
})
export default class JobAlertPageV2 extends Vue {
  $wlToastr: any;
  public keywords: string = '';
  public createAlert: boolean = false;
  public filterforJobalerts: boolean = true;
  public remoteJobType: string[] = [];
  private selectedJobAlert: JobAlertUI = new JobAlertUI();
  private deleteSelected: boolean = false;
  private selectedJobAlertToDelete: JobAlertUI = new JobAlertUI();
  private selectedJobAlertToEditV2: JobAlertV2 = new JobAlertV2();
  private deleteSelectedJob: JobDeleteV2 = new JobDeleteV2();
  private PauseSelectedJob: JobAlertPauseV2 = new JobAlertPauseV2();
  private jobList: JobAlertListV2 = new JobAlertListV2();
  private locationInfo: JobAlertLocationInfo = new JobAlertLocationInfo();
  private jp: Pager = new Pager();
  private CommonJobAlertV2: CommonJobAlertV2 = new CommonJobAlertV2();
  private addressSearchText: string = '';
  private errorString: string = '';
  private successString: string = '';
  private sucessMessage: string = '';
  private userProfile: UserProfile = new UserProfile();
  private notificationPreference: NotificationPreferences = new NotificationPreferences();
  private commonJobAlert: CommonJobAlert = new CommonJobAlert();
  private latitude: number = 0.0;
  private selectedEntire: boolean = false;
  private longitude: number = 0.0;
  private locale: Locale = new Locale();
  private jobAlerts: any[] = [];
  private editPopAlert: boolean = false;
  private addressSearchTextEdit: string = '';
  private latitudeEdit: number = 0.0;
  private longitudeEdit: number = 0.0;
  private jobStatus: boolean = false;
  private localeEdit: Locale = new Locale();
  private locationText: string = '';
  private googleAddressValue: boolean = false;
  private componentKey: number = 0;
  private frequencyPicked: string = '';
  private fields = { text: 'text', value: 'value' };
  private manageAlertsMode: boolean = false;
  private selectAll: boolean = false;
  private id: number = 0;
  private filterMapping: any = '';
  private filterName: any = '';
  private test: boolean = false;
  private filterValue: any = '';
  private filterData: any = '';
  private filterList: any = [];
  private selectedCheckBox: any = [];
  private selectAllCheckBox: boolean = false;
  private userPreferenceEmail: boolean = false;
  private userPreferenceSMS: boolean = false;
  private userPreferencePush: boolean = false;
  private userPreferenceWhatsapp: boolean = false;
  private pageSize: any = '';
  private totalCount: any = '';
  get isLoggedIn() {
    return vxm.users.isLoggedIn;
  }

  async newSearch() {
    let jobListParamsV2: JobSearchRequestPayload = new JobSearchRequestPayload();
    vxm.jobs.setJobListParamsV2(jobListParamsV2);
    this.$router.push({ name: 'Findjobs' });
  }

  setFilterValues(appliedFilter, radius, location, sortValue): any {
    if (!this.filterData) return;

    const filters = this.filterData.jobFilterMetaDataVOList;
    const filter = filters.forEach((filter) => {
      if (appliedFilter.name == filter.name) {
        if (
          appliedFilter.displayType == 'salaryrange' ||
          appliedFilter.displayType == 'text' ||
          appliedFilter.displayType == 'select'
        ) {
          filter.defaultValue = appliedFilter.value;
        } else if (appliedFilter.displayType == 'range') {
          if (radius != '') {
            filter.defaultValue = radius;
            this.locationInfo.radius = radius;
          }
        } else if (appliedFilter.displayType == 'multi-select') {
          filter.defaultValue = appliedFilter.value.split(',');
        }
      } else if (
        filter.displayType == 'select' &&
        !filter.hasOwnProperty('defaultValue')
      ) {
        filter.defaultValue = '';
      }
    });

    let locationFilter = filters.find(
      (filter) => filter.displayType === 'location',
    );
    if (locationFilter) {
      locationFilter.defaultValue = location;
    }

    let sortFilter = filters.find(
      (filter) => filter.name === 'JobPosting.SortCriteria',
    );
    if (sortFilter) {
      sortFilter.defaultValue = sortValue;
    }
  }

  async newLink(jobalert: any) {
    this.locationInfo = new JobAlertLocationInfo();
    var appliedFilters = jobalert.jobAlertConfigDetails.jobParamRequests;
    var locationInfo = jobalert.jobAlertConfigDetails.locationInfo;
    var sortInfo = jobalert.jobAlertConfigDetails.sortCriteria;
    vxm.jobs.setFilterForJobAlerts(true);
    const filterDataResponse = await vxm.jobs.fetchFiltersData();
    this.filterData =
      filterDataResponse && filterDataResponse.data
        ? filterDataResponse.data
        : null;
    if (locationInfo != null) {
      var radius = locationInfo.radius;
      var location = locationInfo.location;
      this.locationInfo.radius = locationInfo.radius;
      this.locationInfo.location = locationInfo.location;
    }
    if (sortInfo != null) {
      var sortValue = sortInfo.sortField;
    }
    if (location != null && location.length > 0) {
      (this.locationInfo.locShortName = locationInfo.locShortName),
        (this.locationInfo.latLong.latitude = locationInfo.latLong.latitude);
      this.locationInfo.latLong.longitude = locationInfo.latLong.longitude;
      this.locationInfo.locationType = locationInfo.locationType;
    }
    if (appliedFilters.length > 0) {
      appliedFilters.forEach((appliedFilter) => {
        this.setFilterValues(appliedFilter, radius, location, sortValue);
      });
    } else {
      this.filterData.jobFilterMetaDataVOList.forEach((filter) => {
        if (
          filter.displayType == 'select' &&
          !filter.hasOwnProperty('defaultValue')
        ) {
          filter.defaultValue = '';
        } else if (filter.name === 'JobPosting.SortCriteria') {
          filter.defaultValue = sortValue;
        }
      });
    }
    router.push({ name: 'Findjobs' });
    let jobListParamsV2: JobSearchRequestPayload = new JobSearchRequestPayload();
    jobListParamsV2.jobParamRequests = appliedFilters.map((filter) => ({
      name: filter.name,
      value: filter.value,
      displayType: filter.displayType,
      fieldType: filter.fieldType,
    }));
    jobListParamsV2.locationInfo = locationInfo;
    vxm.jobs.setJobListParamsV2(jobListParamsV2);
    vxm.jobs.setJobAlertLocationInfo(this.locationInfo);
    vxm.jobs.setJobAlertFilterURL(this.filterData);
  }
  jobConfigFilterMappings(valfilter) {
    this.filterName = '';
    this.filterValue = '';
    var matchFound = false;
    this.filterMapping.forEach((element) => {
      if (element.name == valfilter.name && !matchFound) {
        if (
          element.displayType == 'salaryrange' ||
          element.displayType == 'range' ||
          element.displayType == 'text'
        ) {
          this.filterName = element.displayType;
          this.filterValue = element.value;
          matchFound = true;
        } else if ((element.displayType = 'multi-select')) {
          this.filterName = element.label;
          var value = this.multiSelectMapping(element, valfilter);
          this.filterValue = value.toString();
          matchFound = true;
        }
      }
    });
  }
  get presentPageNumber() {
    return vxm.jobs.MyJobAlertPager.resultPage;
  }
  get alertsCount() {
    return vxm.jobs.MyJobAlertPager.resultSize;
  }
  multiSelectMapping(ele, val): any {
    var filterValues = ele.displayList.split(',');
    var filterKeys = ele.valueList.split(',');
    var jobAlertKeys = val.value.split(',');
    var filterMappings = {};
    var configArray: any = [];
    filterKeys.forEach((key, i) => (filterMappings[key] = filterValues[i]));

    jobAlertKeys.forEach((element) => {
      var mappingvalue: any = filterMappings[element];
      configArray.push(mappingvalue);
    });
    return configArray;
  }
   mounted() {
    const resp2: any = vxm.jobs.fetchFiltersData();
    // const getProfile :any = vxm.users.getUserProfile();

    Promise.all([resp2]).then(
      (response) => {
        if (response) {
          this.filterMapping = response[0].data.jobFilterMetaDataVOList;
        }
      },
      (err) => {
        console.debug(err);
        this.$wlToastr(
          'error',
          this.$t('JobAlert_CantLoadJobAlertsMsg').toString(),
          this.$t('JobAlert_JobAlert').toString(),
        );
      },
    );
    // this.userProfile = vxm.users.myUserProfile;
    this.notificationPreference = vxm.notificationpreference.userNotificationPreferences;
    this.notificationAssign();

    this.jobList.companyCode = vxm.jobs.BrandingInfo.companycode;
    this.jobList.pageNumber = 1;
    this.jobList.email = vxm.users.myUserProfile.email;
    const respPromise: any = vxm.jobs.getJobAlertsV2(this.jobList);

    // const frequencyRespPromise: any = vxm.jobs.getJobAlertsFrequency();

    Promise.all([respPromise]).then(
      (response) => {
        if (response) {
          this.jobAlerts = response[0].data.jobAlertList;
          this.jobList = new JobAlertListV2();
          this.assignCheckBoxId();
          vxm.jobs.setJobAlerts(this.jobAlerts);
          this.pageSize = vxm.jobs.MyJobAlertPager.resultCount;
          this.totalCount = vxm.jobs.MyJobAlertPager.resultSize;
        }
      },
      (err) => {
        console.debug(err);
        this.$wlToastr(
          'error',
          this.$t('JobAlert_CantLoadJobAlertsMsg').toString(),
          this.$t('JobAlert_JobAlert').toString(),
        );
      },
    );
  }

  get jobAlertList(): any {
    this.pageRefreshed;
    return vxm.jobs.JobAlertListings;
  }

  assignCheckBoxId() {
    this.selectedCheckBox = [];
    for (var i = 0; i < this.jobAlertList.length; i++) {
      this.selectedCheckBox.push({ id: this.jobAlertList[i].id, value: false });
    }
  }
  get pageRefreshed() {
    if (vxm.jobs.AlertRefresh) {
      vxm.jobs.setAlertRefresh(false);
      this.selectedCheckBox = [];
      this.selectedEntire = false;
      this.selectAllCheckBox = false;
      this.assignCheckBoxId();
    }
    return vxm.jobs.AlertRefresh;
  }
  async manageFrequency() {
    const payload = {
      userId: vxm.users.myUserProfile.userId,
      frequency: this.frequencyPicked,
    };
    let respPromise = vxm.jobs.updateJobAlertFrequency(payload);
    const resp = await respPromise;
    if (resp.meta.success) {
      this.$wlToastr('success', this.$t('jobalert-frequency-updated-message'));
    } else {
      this.$wlToastr('error', this.$t('jobalert-frequency-updated-failed'));
    }
  }

  onAddressTextChange(text: string) {
    this.addressSearchText = text;
  }

  getAddressData(addressData, placeResultData, id) {
    this.latitude = addressData.latitude;
    this.longitude = addressData.longitude;
    this.locale.city = addressData.locality;
    this.locale.state = addressData.administrative_area_level_1;
    this.locale.country = addressData.country;
    this.locationText = addressData;
    this.googleAddressValue = true;
  }
  changeCheckBoxState(value) {
    for (var i = 0; i < this.selectedCheckBox.length; i++) {
      this.selectedCheckBox[i]['value'] = value;
    }
  }
  toggleCheckBox() {
    if (this.selectAllCheckBox) {
      this.changeCheckBoxState(true);
    } else {
      this.changeCheckBoxState(false);
    }
  }
  changeToggleState() {
    var checkbox: any = document.getElementById('option');
    if (this.selectAllCheckBox) {
      if (checkbox.indeterminate) {
        this.unSelectedAll();
      }
      this.changeCheckBoxState(false);
      this.selectAllCheckBox = false;
    } else {
      this.changeCheckBoxState(true);
      this.selectAllCheckBox = true;
    }
  }

  onNoResults() {
    this.$wlToastr('error', this.$t('please-enter-valid-location-error-text'));
  }
  ////////////////Create Mthods ///////////////////////////////
  createJobAlert() {
    /* if (!this.keywords) {
      this.keywords = null;
    }*/
    let locale = new Locale();
    locale.city = '';
    locale.state = '';
    locale.country = '';

    let latlong = new Latlong();
    if (!this.addressSearchText) {
      latlong.latitude = vxm.jobs.latitude;
      latlong.longitude = vxm.jobs.longitude;
    }
    latlong.latitude = this.latitude;
    latlong.longitude = this.longitude;

    let geoLocation = new Geolocation();
    geoLocation.requestPref = 'LATLONG';
    geoLocation.locale = this.locale;
    geoLocation.latLong = latlong;
    if (!this.locale.city && this.locale.state) {
      geoLocation.locationType = 'administrative_area_level_1';
      geoLocation.locShortName = this.locale.state;
    } else {
      geoLocation.locationType = '';
      geoLocation.locShortName = '';
    }
    let alertConfigDetails = new AlertConfigDetails();
    alertConfigDetails.textCriteria = this.keywords;
    alertConfigDetails.address = this.addressSearchText;

    alertConfigDetails.latLong = latlong;
    alertConfigDetails.geoLocation = geoLocation;

    let jobAlertFilter = new Filter();
    jobAlertFilter.remoteJobType = this.remoteJobType;

    let jobAlert = new JobAlertUI();
    if (!this.keywords) {
      jobAlert.name = 'All Jobs';
    } else {
      jobAlert.name = this.keywords;
    }

    jobAlert.email = vxm.users.myUserProfile.email;
    jobAlert.fullName =
      vxm.users.myUserProfile.firstName +
      ' ' +
      vxm.users.myUserProfile.lastName;
    jobAlert.companyCode = vxm.jobs.BrandingInfo.companycode;
    jobAlert.alertConfigDetails = alertConfigDetails;
    jobAlert.filter = jobAlertFilter;
    jobAlert.status = 0;
    jobAlert.isActive = true;
    jobAlert.isValidated = false;
    this.commonJobAlert.jobAlert = jobAlert;
    // this.EditJobAlert.jobAlert = jobAlert;
    this.saveJobAlert();
  }

  validJobAlert(): boolean {
    let isValid = false;
    if (this.keywords || this.addressSearchText) {
      isValid = true;
    } else {
      this.$wlToastr('error', this.$t('JobAlert_MandatoryTitleOrLocationMsg'));
      isValid = false;
    }
    return isValid;
  }
  fetchJobAlertList() {
    this.jobList.companyCode = vxm.jobs.BrandingInfo.companycode;
    this.jobList.pageNumber = this.presentPageNumber;
    this.jobList.email = vxm.users.myUserProfile.email;
    const respPromise: any = vxm.jobs.getJobAlertsV2(this.jobList);
    Promise.all([respPromise]).then(
      (response) => {
        if (response) {
          this.jobAlerts = response[0].data.jobAlertList;
          if (
            response[0].data.jobAlertList.length == 0 &&
            this.presentPageNumber != 1
          ) {
            this.jp.resultPage = this.presentPageNumber - 1;
            vxm.jobs.setMyAlertPager(this.jp);
            this.fetchJobAlertList();
          } else {
            this.assignCheckBoxId();
            this.selectAllCheckBox = false;
            vxm.jobs.setJobAlerts(this.jobAlerts);
            this.$wlToastr('success', this.sucessMessage);
          }
          this.pageSize = vxm.jobs.MyJobAlertPager.resultCount;
          this.totalCount = vxm.jobs.MyJobAlertPager.resultSize;
        }
      },
      (err) => {
        console.debug(err);
        this.$wlToastr(
          'error',
          this.$t('JobAlert_CantLoadJobAlertsMsg').toString(),
          this.$t('JobAlert_JobAlert').toString(),
        );
      },
    );
    return false;
  }
  saveJobAlert() {
    if (this.validJobAlert()) {
      vxm.jobs.createCommonJobAlert(this.commonJobAlert).then((res) => {
        if (res.success === true) {
          this.commonJobAlert.jobAlert.id = res.jobAlertId;
          this.jobAlerts.unshift(this.commonJobAlert.jobAlert);
          vxm.jobs.setJobAlerts(this.jobAlerts);
          this.$wlToastr(
            'success',
            this.$t(this.successString),
            this.getJobAlertSuccessMessage(),
          );
          this.commonJobAlert = new CommonJobAlert();
        } else {
          this.$wlToastr(
            'error',
            res.errorMessage,
            this.$t('JobAlert_JobAlert').toString(),
          );
        }
      });
    }
    this.componentKey += 1;
    this.googleAddressValue = false;
  }

  getJobAlertSuccessMessage() {
    if (vxm.users.isLoggedIn) {
      return this.$t('jobalert-created-success-message');
    }
    return this.$t('jobalert-created-anon-success-message');
  }
  //////////////////////////////////////////////////

  deleteJobAlert(val: any) {
    this.$modal.show(
      ConfirmationModalV2,
      {
        header: this.$t('jobalert-delete-modal-title'),
        body: this.$t('jobalert-delete-modal-message'),
        okText: this.$t('global.confirm-text'),
        cancelText: this.$t('global.cancel-text'),
        onOk: this.deleteSelectedJobAlert,
      },
      {
        height: 'auto',
        clickToClose: false,
      },
    );
    //const vm = this;
    // this.deleteSelected = true;
    if (!this.editPopAlert) {
      this.deleteJob(val);
    } else {
      this.deleteJobAlertFromEdit();
    }
  }
  deleteJobAlertFromEdit() {
    this.editPopAlert = false;
    this.deleteSelectedJob.companyCode = vxm.jobs.BrandingInfo.companycode;
    (this.deleteSelectedJob.email = vxm.users.myUserProfile.email),
      this.deleteSelectedJob.jobAlertIds.push(vxm.jobs.JobAlertId);
  }
  deleteJob(val) {
    this.deleteSelectedJob.companyCode = vxm.jobs.BrandingInfo.companycode;
    (this.deleteSelectedJob.email = vxm.users.myUserProfile.email),
      this.deleteSelectedJob.jobAlertIds.push(val.id);
  }
  saveEditJobAlert() {
    const vm = this;
    // job alert = new JobAlertV2
  }

  deleteSelectedJobAlert() {
    const vm = this;
    const selectedJobAlertIdBeforeDelete = this.selectedJobAlertToDelete.id;
    vxm.jobs.deleteJobAlertV2(this.deleteSelectedJob).then((res) => {
      if (res.data.success === true) {
        this.fetchJobAlertList();
        this.selectedEntire = false;
        vxm.users.Rudderstack.trackEvent("Job Alert Deleted", {
          jobAlertId: selectedJobAlertIdBeforeDelete,
          jobAlertFrequency:vxm.jobs.getJobAlertsFrequency()
          });
        this.sucessMessage = this.$t('jobalert-delete-modal-success-message').toString();
        this.deleteSelectedJob = new JobDeleteV2();
      } else {
        this.$wlToastr('error', res.errorMessage);
      }
    });
    this.componentKey += 1;
  }
  cancelDeleteJobAlert() {
    this.deleteSelected = false;
    this.selectedJobAlertToDelete = new JobAlertUI();
  }
  deletAllJobAlert() {
    this.$modal.show(
      ConfirmationModalV2,
      {
        header: this.$t('jobalert-delete-all-modal-title'),
        body: this.$t('jobalert-delete-all-modal-message'),
        onOk: this.deleteAllAlerts,
        okText: this.$t('global.confirm-text'),
        cancelText: this.$t('global.cancel-text'),
      },
      {
        height: 'auto',
        clickToClose: false,
      },
    );
  }

  activateInactiveJobAlert(jobalert) {
    this.$modal.show(
      ConfirmationModalV2,
      {
        header: this.$t('jobalert-resend-email-modal-title'),
        body: this.$t('jobalert-resend-email-modal-message', { email: vxm.users.myUserProfile.email.bold() }),
        okText: this.$t('global.confirm-text'),
        cancelText: this.$t('global.cancel-text'),
        onOk: () => {
          this.resendActivationEmail(jobalert);
        },
      },
      {
        height: 'auto',
        clickToClose: false,
      },
    );
  }

  resendActivationEmail(jobalert) {
    vxm.jobs.triggerJobAlertActivationEmail(jobalert.id).then(async (res) => {
      if (res.meta.success === true) {
        this.sucessMessage = this.$t('jobalert-activation-modal-success-message').toString();
        this.$wlToastr('success', this.sucessMessage);
      } else {
        this.$wlToastr(
          'error',
          'Error - while sending job alert cativation email',
        );
      }
    });
  }
  resumeAllJobAlert() {
    this.$modal.show(
      ConfirmationModalV2,
      {
        header: this.$t('jobalert-resume-modal-title'),
        body: this.$t('jobalert-resume-modal-message'),
        onOk: this.resumeAllAlerts,
        okText: this.$t('global.confirm-text'),
        cancelText: this.$t('global.cancel-text'),
      },
      {
        height: 'auto',
        clickToClose: false,
      },
    );
  }
  //pause all jobs pop up
  pauseAllJobAlert() {
    this.$modal.show(
      ConfirmationModalV2,
      {
        header: this.$t('jobalert-pause-modal-title'),
        body: this.$t('jobalert-pause-modal-message'),
        onOk: this.pauseAllAlerts,
        okText: this.$t('global.confirm-text'),
        cancelText: this.$t('global.cancel-text'),
      },
      {
        height: 'auto',
        clickToClose: false,
      },
    );
  }

  pauseJobAlert(val) {
    this.$modal.show(
      ConfirmationModalV2,
      {
        header: this.$t('jobalert-pause-modal-title'),
        body: this.$t('jobalert-pause-modal-message'),
        onOk: this.pauseJobAlerts,
        okText: this.$t('global.confirm-text'),
        cancelText: this.$t('global.cancel-text'),
      },
      {
        height: 'auto',
        clickToClose: false,
      },
    );
    this.pauseAlertJob(val);
  }
  activateJobAlert(jobalert) {
    this.$modal.show(
      ConfirmationModalV2,
      {
        header: this.$t('jobalert-resume-modal-title'),
        body: this.$t('jobalert-resume-modal-message'),
        onOk: this.activateAlertJob,
        okText: this.$t('global.confirm-text'),
        cancelText: this.$t('global.cancel-text'),
      },
      {
        height: 'auto',
        clickToClose: false,
      },
    );
    vxm.jobs.setJobAlertId(jobalert.id);
  }
  activateAlertJob(val) {
    vxm.jobs
      .activateJobAlertV2(vxm.users.myUserProfile.email)
      .then(async (res) => {
        if (res.data.success === true) {
          this.fetchJobAlertList();
          vxm.users.Rudderstack.trackEvent("Job Alert Resumed", {
            jobAlertId: this.commonJobAlert.jobAlert.id,
            jobAlertFrequency : vxm.jobs.getJobAlertsFrequency()
          });
          this.sucessMessage = this.$t('jobalert-resume-modal-success-message').toString();
        } else {
          this.$wlToastr('error', res.errorMessage);
        }
      });
  }
  pauseAlertJob(val) {
    this.PauseSelectedJob.companyCode = vxm.jobs.BrandingInfo.companycode;
    (this.PauseSelectedJob.email = vxm.users.myUserProfile.email),
      this.PauseSelectedJob.jobAlertIds.push(val.id);
    vxm.jobs.setJobAlertId(val.id);
  }
  pauseJobAlerts() {
    const vm = this;
    vxm.jobs.pauseJobAlertV2(this.PauseSelectedJob).then(async (res) => {
      if (res.data.success === true) {
        this.fetchJobAlertList();
        vxm.users.Rudderstack.trackEvent("Job Alert Paused", {
          jobAlertId: this.commonJobAlert.jobAlert.id,
          jobAlertFrequency : vxm.jobs.getJobAlertsFrequency()
        });
        this.sucessMessage = this.$t('jobalert-pause-modal-success-message').toString();
        this.PauseSelectedJob = new JobAlertPauseV2();
        this.selectAll = false;
      } else {
        this.$wlToastr('error', res.errorMessage);
      }
    });
    this.componentKey += 1;
  }
  get CheckedId(): any {
    var delId: any = [];
    this.selectedCheckBox.map(function(el) {
      if (el.value) {
        delId.push(el.id);
      }
    });
    return delId;
  }
  selectedAll() {
    var checkbox: any = document.getElementById('option');
    this.selectedEntire = true;
    checkbox.indeterminate = false;
    this.selectAllCheckBox = true;
    this.assignCheckBoxId();
    this.changeCheckBoxState(true);
    this.CheckedId;
  }
  unSelectedAll() {
    this.selectedEntire = false;
    this.selectAllCheckBox = false;
    var checkbox: any = document.getElementById('option');
    checkbox.indeterminate = false;
    this.selectAllCheckBox = false;
    this.assignCheckBoxId();
    this.CheckedId;
  }
  resumeAllAlerts() {
    const payload = {
      jobAlertIds: this.CheckedId,
      companyCode: vxm.jobs.BrandingInfo.companycode,
      email: vxm.users.myUserProfile.email,
      activateAllJobAlerts: this.selectedEntire,
    };
    if (this.CheckedId.length > 0) {
      vxm.jobs.resumeAllAlerts(payload).then((res) => {
        if (res.data.success === true) {
          this.fetchJobAlertList();
          this.sucessMessage = this.$t('jobalert-resume-modal-success-message').toString();
          this.selectAll = false;
        } else {
          this.$wlToastr('error', res.errorMessage);
        }
      });
    } else {
      this.$wlToastr(
        'error',
        this.$t('jobalert-please-select-atleast-one-msg').toString(),
        this.$t('jobalert-resume-modal-title').toString(),
      );
    }
  }
  pauseAllAlerts() {
    var checkedId: any = this.CheckedId;
    this.PauseSelectedJob.companyCode = vxm.jobs.BrandingInfo.companycode;
    this.PauseSelectedJob.email = vxm.users.myUserProfile.email;
    this.PauseSelectedJob.jobAlertIds = checkedId;
    if (this.selectedEntire) {
      this.PauseSelectedJob.pauseAllJobAlerts = true;
    }
    if (this.CheckedId.length > 0) {
      this.pauseJobAlerts();
    } else {
      this.$wlToastr(
        'error',
        this.$t('jobalert-please-select-atleast-one-msg').toString(),
        this.$t('jobalert-pause-modal-title').toString(),
      );
    }
  }
  deleteAllAlerts() {
    this.deleteSelectedJob.companyCode = vxm.jobs.BrandingInfo.companycode;
    this.deleteSelectedJob.email = vxm.users.myUserProfile.email;
    var checkedId: any = this.CheckedId;
    this.deleteSelectedJob.jobAlertIds = checkedId;
    if (this.selectedEntire) {
      this.deleteSelectedJob.deleteAllJobAlerts = true;
    }
    if (this.CheckedId.length > 0) {
      this.deleteSelectedJobAlert();
    } else {
      this.$wlToastr(
        'error',
        this.$t('jobalert-please-select-atleast-one-msg').toString(),
        this.$t('jobalert-delete-modal-title').toString(),
      );
    }
  }

  ////////////////////// Delete End

  onAddressTextChangeEdit(text: string) {
    this.addressSearchTextEdit = text;
  }
  changeState() {
    var checkbox: any = document.getElementById('option');
    if (
      this.selectAllCheckBox &&
      this.CheckedId.length < this.pageSize &&
      this.CheckedId.length != 0
    ) {
      checkbox.indeterminate = true;
    } else if (this.CheckedId.length == 0) {
      checkbox.indeterminate = false;
      this.selectAllCheckBox = false;
    } else if (this.CheckedId.length == this.pageSize) {
      checkbox.indeterminate = false;
      this.selectAllCheckBox = true;
    }
  }

  getAddressDataEdit(addressData, placeResultData, id) {
    this.latitudeEdit = addressData.latitude;
    this.longitudeEdit = addressData.longitude;
    this.localeEdit.city = addressData.locality;
    this.localeEdit.state = addressData.administrative_area_level_1;
    this.localeEdit.country = addressData.country;
  }

  onNoResultsEdit() {
    this.$wlToastr('error', this.$t('please-enter-valid-location-error-text'));
  }

  // editJobAlert(val: JobAlertUI) {
  //   this.selectedJobAlert.id = val.id;
  //   this.selectedJobAlert.name = val.name;
  //   this.selectedJobAlert.email = val.email;
  //   this.selectedJobAlert.fullName = val.fullName;
  //   this.selectedJobAlert.alertConfigDetails = val.alertConfigDetails;
  //   this.selectedJobAlert.filter.remoteJobType = val.filter.remoteJobType;
  //   this.selectedJobAlert.status = val.status;
  //   this.selectedJobAlert.isActive = val.isActive;
  //   this.selectedJobAlert.isValidated = val.isValidated;
  //   this.addressSearchTextEdit = val.alertConfigDetails.address;
  //   this.latitudeEdit = val.alertConfigDetails.geoLocation.latLong.latitude;
  //   this.longitudeEdit = val.alertConfigDetails.geoLocation.latLong.longitude;
  //   this.localeEdit.city = val.alertConfigDetails.geoLocation.locale.city;
  //   this.localeEdit.state = val.alertConfigDetails.geoLocation.locale.state;
  //   this.localeEdit.country = val.alertConfigDetails.geoLocation.locale.country;
  // }

  cancelEditJobAlert() {
    this.selectedJobAlert = new JobAlertUI();
  }

  validEditedJobAlert(): boolean {
    let isValid = false;
    if (this.selectedJobAlertToEditV2.name.length > 0) {
      isValid = true;
    } else {
      this.$wlToastr('error', 'Name of Job alert is mandatory');
      isValid = false;
    }
    return isValid;
  }
  JobAlertEditPopUp(resp) {
    this.editPopAlert = true;
    this.$modal.show(
      JobAlertEditPopUp,
      {
        header: this.$t('jobalert.manage.alerts'),
        body: this.$t('jobalert.manage.getnotified.msg'),
        okText: this.$t('global-update-text'),
        cancelText: this.$t('global.cancel-text'),
        jobAlertStatus: this.jobStatus,
        isMobileDevice: this.mobileDevice,
        onOk: this.saveEditedJobAlert,
        filterList: this.filterList,
        onDelete: this.deleteJobAlert,
        notificationSMS: this.userPreferenceSMS,
        notificationWhatsapp: this.userPreferenceSMS,
        notificationPush: this.userPreferencePush,
        notificationEmail: this.userPreferenceEmail,

        onToggle: this.toggleValue,
        jobresponse: this.selectedJobAlertToEditV2,
      },
      {
        height: 'auto',
        clickToClose: false,
        class: 'mainclass',
      },
    );
    vxm.jobs.setJobAlertId(resp.id);
  }
  toggleValue(val) {
    this.selectedJobAlertToEditV2.status = val == true ? '1' : '0';
  }

  EditedJobAlert(resp) {
    this.selectedJobAlertToEditV2.name = resp.name;
    this.selectedJobAlertToEditV2.email = vxm.users.myUserProfile.email;
    this.selectedJobAlertToEditV2.companyCode =
      vxm.jobs.BrandingInfo.companycode;
    this.selectedJobAlertToEditV2.status = resp.status;
    this.selectedJobAlertToEditV2.jobAlertFrequency = resp.jobAlertFrequency;
    this.selectedJobAlertToEditV2.notificationType.email =
      resp.notificationType.email;
    this.selectedJobAlertToEditV2.notificationType.sms =
      resp.notificationType.sms;
    this.selectedJobAlertToEditV2.notificationType.push = resp.notificationType.push;
    this.jobStatus = resp.status == 0 ? false : true;
    this.id = resp.id;
    this.getFilterValues(resp);

    this.JobAlertEditPopUp(resp);
  }
  getFilterValues(resp: any) {
    this.filterList = [];
    if (
      resp.jobAlertConfigDetails.locationInfo != null &&
      resp.jobAlertConfigDetails.locationInfo.location != null
    ) {
      this.filterList.push(
        `${this.$t('jobalert.label.location')}: ${resp.jobAlertConfigDetails.locationInfo.location}`,
      );
    }
    if (
      resp.jobAlertConfigDetails.locationInfo != null &&
      resp.jobAlertConfigDetails.locationInfo.radius != null
    ) {
      this.filterList.push(
        `${this.$t('JobAlert_RadiusLabel')}: ${this.$t('jobalert.within.miles', {milees: resp.jobAlertConfigDetails.locationInfo.radius})}`,
      );
    }
    resp.jobAlertConfigDetails.jobParamRequests.forEach((filter, index) => {
      if (
        filter.name != 'Facility.location' &&
        filter.name != 'Facility.radius'
      ) {
        if (filter.name == 'JobPosting.searchField') {
          this.filterList.push(filter.label + ':\xa0' + filter.value);
        } else if (filter.displayType == 'salaryrange') {
          this.filterList.push(filter.label + ':\xa0' + filter.displayValue);
        } else if (filter.displayType == 'text') {
          this.filterList.push(filter.label + ':\xa0' + filter.value);
        } else if (filter.displayType == 'select') {
          this.filterList.push(filter.label + ':\xa0' + filter.displayValue);
        } else if (
          filter.displayValue &&
          filter.displayValue.length > 0 &&
          filter.displayType == 'multi-select'
        ) {
          var arr = filter.displayValue.split(',');
          if (arr.length > 1) {
            var extralength = arr.length - 1;
            this.filterList.push(
              filter.label + ':\xa0' + arr[0] + ',+' + extralength + '\xa0more',
            );
          } else {
            this.filterList.push(filter.label + ':\xa0' + arr[0]);
          }
        }
      }
    });
  }
  notificationMap() {
    if (
      // !this.userProfile.notificationTypeMap.EMAIL
      !this.notificationPreference.email &&
      this.CommonJobAlertV2.jobAlert.notificationType.email
    ) {
      // this.userProfile.notificationTypeMap.EMAIL
      this.notificationPreference.email = this.CommonJobAlertV2.jobAlert.notificationType.email;
    }
    if (
      // !this.userProfile.notificationTypeMap.SMS 
      !this.notificationPreference.sms &&
      this.CommonJobAlertV2.jobAlert.notificationType.sms
    ) {
      // this.userProfile.notificationTypeMap.SMS 
     this.notificationPreference.sms = this.CommonJobAlertV2.jobAlert.notificationType.sms;
    }
    if (
      // !this.userProfile.notificationTypeMap.PUSH_NOTIFICATION
      !this.notificationPreference.push &&
      this.CommonJobAlertV2.jobAlert.notificationType.push
    ) {
      // this.userProfile.notificationTypeMap.PUSH_NOTIFICATION
       this.notificationPreference.push = this.CommonJobAlertV2.jobAlert.notificationType.push;
    }
  }
  notificationAssign() {
    console.log("notificationAssign......");
    this.userPreferenceEmail = this.notificationPreference.email;
    // this.userProfile.notificationTypeMap.EMAIL;
    this.userPreferenceSMS = this.notificationPreference.sms;
    //  this.userProfile.notificationTypeMap.SMS;
    this.userPreferencePush = this.notificationPreference.push;
    // this.userProfile.notificationTypeMap.PUSH_NOTIFICATION;
    this.userPreferenceWhatsapp = this.notificationPreference.whatsapp;
    // this.userProfile.notificationTypeMap.WHATSAPP;
  }

  saveEditedJobAlert() {
    this.CommonJobAlertV2.jobAlert = this.selectedJobAlertToEditV2;
    this.notificationMap();

    this.updateJobAlert();
  }
  get mobileDevice() {
    return vxm.utility.isMobileDevice;
  }
  async updateJobAlert() {  
    if (this.validEditedJobAlert()) {
      vxm.jobs.setJobAlertId(this.id);
      vxm.jobs.updateCommonJobAlertV2(this.CommonJobAlertV2).then((res) => {
        if (res.data.success === true) {
          this.fetchJobAlertList();
          vxm.users.Rudderstack.trackEvent("Job Alert Updated", {
            jobAlertId: this.commonJobAlert.jobAlert.id,
            jobAlertFrequency: vxm.jobs.getJobAlertsFrequency(),
            filterCriteria : this.selectedJobAlert.filter
          });
          this.sucessMessage = this.$t('JobAlert_AlertSavedSuccessfulyMsg').toString();
          this.selectedJobAlertToEditV2 = new JobAlertV2();
          this.CommonJobAlertV2 = new CommonJobAlertV2();
          vxm.jobs.setJobAlertId(this.id);
          // const respPromise: any = vxm.users.saveUserProfile({
          //   userProfile: this.userProfile,
          //   isPartofRegistration: false,
          // });
          // this.userProfile = vxm.users.myUserProfile;
          const respPromise : any = vxm.notificationpreference.updateUserNotificationPreferences(this.notificationPreference);
          this.notificationPreference = vxm.notificationpreference.userNotificationPreferences;
          this.notificationAssign();
        } else {
          this.$wlToastr(
            'error',
            res.data.errorMessage,
            this.$t('JobAlert_JobAlert').toString(),
          );
        }
      });
    }
    this.componentKey += 1;
  }

  get remoteJobTypes() {
    return [
      { value: 'yes', text: 'Yes' },
      { value: 'no', text: 'No' },
      { value: 'partial', text: 'Partial' },
    ];
  }

  getRemoteJobType(jobalert) {
    const remoteJobTypes = jobalert.filter.remoteJobType.map((remoteType) =>
      remoteType.toLowerCase(),
    );
    if (remoteJobTypes.length === 1 && remoteJobTypes.includes('yes')) {
      return 'Remote Jobs: Yes';
    } else if (remoteJobTypes.length === 1 && remoteJobTypes.includes('no')) {
      return 'Remote Jobs: No';
    } else if (
      remoteJobTypes.length === 2 &&
      remoteJobTypes.includes('yes') &&
      remoteJobTypes.includes('partial')
    ) {
      return 'Remote Jobs: Yes, Partial';
    } else if (
      remoteJobTypes.length === 2 &&
      remoteJobTypes.includes('no') &&
      remoteJobTypes.includes('partial')
    ) {
      return 'Remote Jobs: No, Partial';
    } else if (
      remoteJobTypes.length === 2 &&
      remoteJobTypes.includes('no') &&
      remoteJobTypes.includes('yes')
    ) {
      return 'Remote Jobs: Yes, No';
    }
    return '';
  }
}
